import { Suspense } from "react";
import { createRoot } from "react-dom/client";
// import { inspect } from "@xstate/inspect";

import { QueryClientProvider } from "react-query";
import { config as authConfig } from "marvin-auth-kit";
import { ReactQueryDevtools } from "react-query/devtools";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";

import { App } from "./App";
import { CssBaseline, ThemeProvider, StyledEngineProvider } from "@mui/material";
import { theme } from "./config/theme";
import { PageLoader } from "./components/page/loading/PageLoader";
import { GlobalStyle } from "./styles/GlobalStyle";
import { queryClient } from "./query-client";
import "./i18n";

var Buffer = require("buffer/").Buffer; // note: the trailing slash is important!
// @ts-ignore
window.Buffer = Buffer;

// xstate inspect
if (process.env.NODE_ENV === "development") {
  // inspect({
  //   iframe: false, // open in new window
  // });
}

authConfig.set({ path: "/auth-api" });

const MOUNT_NODE = document.getElementById("root");
const root = createRoot(MOUNT_NODE!);

root.render(
  <QueryClientProvider client={queryClient}>
    <Suspense fallback={<PageLoader />}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyle />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>
    </Suspense>
    <ReactQueryDevtools initialIsOpen={true} />
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
